import type { TranslationResource } from './en';

export const jp: TranslationResource = {
  title: 'AutoCut - インストーラー',
  downloading: 'AutoCut をダウンロードしています',
  downloadedTitle: 'AutoCut のダウンロードが完了しました !',
  closingCountdown: '{{count}} 秒後に閉じます',
  alreadyInstalledTitle: 'AutoCut はすでにインストールされています',
  alreadyInstalledHelp:
    'AutoCut はデスクトップアプリとして動作するようになりました。この拡張機能は Creative Cloud アプリからアンインストールできます。',
};
